import { render, staticRenderFns } from "./CardAppointments.vue?vue&type=template&id=d08b1360&scoped=true"
import script from "./CardAppointments.vue?vue&type=script&lang=ts"
export * from "./CardAppointments.vue?vue&type=script&lang=ts"
import style0 from "./CardAppointments.vue?vue&type=style&index=0&id=d08b1360&prod&lang=css"
import style1 from "./CardAppointments.vue?vue&type=style&index=1&id=d08b1360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08b1360",
  null
  
)

export default component.exports